import React from 'react'

const Container = () => {
  return (
    <div>
        <div className='homecontainer'>
            <div className='text'>
                <h3>Connecting you </h3>
                <h1>InternConnect</h1>
                <p>This software would significantly streamline the entire internship placement process, alleviating the burdens faced by everyone involved</p>
                <div className='button'><a href="/about">Explore Now &#8599;</a></div>
            </div>
            <div className='image'>
                <img src="bk.jpg" alt="" />
            </div>
        </div>
       
    </div>
  )
}

export default Container